﻿import React from 'react';
import {Typography, TypographyProps} from "@mui/material";

/**
 * Opinionated typography component for report titles, built on MUI `Typography`.
 *
 * Applies standard styling commonly used for titles in Securspace Reports (e.g. `variant="h5"`, `component="h1"`) without requiring each report view to redeclare those values.
 * @param props - Props are passed directly to the underlying MUI `Typography` component, allowing for additional customization as needed.
 *
 * @example
 * // Simple usage with default styles
 * <SecurSpaceReportTitle>
 *   My Report Title
 * </SecurSpaceReportTitle>
 *
 */
const SecurSpaceReportTitle = (props: TypographyProps) => {
  return <Typography variant={'h5'} component={'h1'} {...props} />
}

export { SecurSpaceReportTitle };
